import { useState, createContext, useContext } from "react";

const CartContext = createContext();

export const CartProvider = ({children})=>{
  const [CartItems, setCartItems] = useState([]);

  const addItems = (item)=>{
    setCartItems(item);
  }
  const removeItems = (item)=>{
    setCartItems([]);
  }
  return(
    <CartContext.Provider value={{CartItems, addItems, removeItems}}>
      {children}
    </CartContext.Provider>
  );
}
export const useCart = () => {
  const ctx = useContext(CartContext);
  if(!ctx) throw new Error("useCart must be used inside CartProvider");
  return ctx;
}
